"use client";

import { AnimatePresence } from "framer-motion";
import { useTranslations } from "next-intl";
import { useState } from "react";

import { AnimatedFading } from "@/components/animations/AnimatedFading";
import { CardWrapper } from "@/components/auth/CardWrapper";
import { LoginForm } from "@/components/auth/LoginForm";
import { RegisterForm } from "@/components/auth/RegisterForm";
import { SiteConfig } from "@/lib/site-config";

export interface IFormsProps {
    inModal?: boolean;
}

export const Forms = ({ inModal = false }: IFormsProps) => {
    const t = useTranslations("auth");

    const [ isLogging, setIsLogging ] = useState(true);

    const onSwitch = () => {
        setIsLogging(!isLogging);
    };

    return (
        <AnimatePresence mode="wait">
            <AnimatedFading id={ isLogging ? "login" : "register" }>
                <CardWrapper
                    headerLabel={ isLogging ? t("login.headerLabel") : t("register.headerLabel") }
                    headerDescription={ isLogging ? t("login.headerDescription") : t("register.headerDescription", { appName: SiteConfig.title }) }
                    backButtonLabel={ isLogging ? t("login.backButtonLabel") : t("register.backButtonLabel") }
                    isLogging={ isLogging }
                    onSwitch={ onSwitch }
                    inModal={ inModal }
                >

                    {isLogging ? <LoginForm /> : <RegisterForm />}

                </CardWrapper>
            </AnimatedFading>
        </AnimatePresence>
    );
};